<template>
    <div
        class="view-settings"
    >
        <div
            v-for="(settingsItem, settingsItemIndex) in settingsItems"
            :key="settingsItemIndex"
        >
        <card
            v-if="!settingsItem.isSettingsPermission || (settingsItem.isSettingsPermission && isSettingsPermission)"
            :title="settingsItem.title"
            :text="settingsItem.text"
            @onClickCard="onClickCard(settingsItem.id)"
        />
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Card from '../../components/Base/Card';
import schemeSettings from '../../schemes/schemeSettings';
import serviceAuth from "../../services/serviceAuth";
let {settingsItems} = schemeSettings;
export default {
    name: 'ViewSettings',
    components: {
        Card
    },
    /**
     * Данные компонента
     * @property {array} settingsItems - список элементов для карточек настроек
     * @property {boolean} isSettingsPermission - право на показ настроек редактирования
     */
    data: () => ({
       settingsItems: settingsItems,
        isSettingsPermission: false
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        })
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Настройки");
        // получаем право на отображение
        this.isSettingsPermission = serviceAuth.checkPermission(this.activeProjectId, 'change_settings');
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * событие клика по карточке
         * @param {number} id - идентификатор элемента списка настроек
         */
        onClickCard(id) {
            let {routeName} = settingsItems.find(item => item.id === id);
            this.$router.push({name: `${routeName}`});
        }
    }
}
</script>

<style lang="scss" scoped>
    .view-settings {
        display: flex;
        flex-wrap: wrap;
    }
</style>